<template>
  <b-card title="METEO">
    <h4>TEMPERATURA MEDIA ESTERNA</h4>

    <Spinner v-if="loading"/>

    <div v-else-if="weather.main" class="text-center">
      <h2>{{ weather.main.temp | celsius | formatDecimal }} °C</h2>
      <h2>{{ weather.main.humidity }} %</h2>
      <h2>{{ weather.main.pressure }} hPa</h2>
    </div>

    <div class="text-right mt-4">
      {{ siteName }}
    </div>
  </b-card>
</template>

<script>
import vector from "./vector";
import {mapState} from "vuex";

export default {
  mixins: [vector],

  filters: {
    celsius(temp) {
      const KELVIN_COEFFICIENT = 273.15;

      return temp - KELVIN_COEFFICIENT;
    },
  },

  data() {
    return {
      weather: {},
    };
  },

  computed: {
    ...mapState({
      user: state => state.user,
      stateSelectedSiteId: state => state.selectedSiteId,
    }),

    siteName() {
      const [ site ] = this.$store.state.user.sites;
      return site ? site.name : '';
    },

    sites() {
      return 'sites' in this.user ? this.user.sites : [];
    },

    selectedSite() {
      return this.sites.length > 1 ?
        this.sites.find((site) => site.guid === this.stateSelectedSiteId)
        : this.sites[0];
    },
  },

  watch: {
    stateSelectedSiteId() {
      this.loadData(true);
    },
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData(force = false) {
      if (this.loading && !force) {
        return;
      }

      try {
        this.loading = true;

        this.weather = await this.$store.dispatch(
          'dashboard/weather', {
            ...this.selectedSite,
            databaseName: this.$store.state.user.databaseName,
          }
        );
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/VectorWidgets/widgets/Weather.vue